





























































































































































































































































































































































import Vue from 'vue';
import eventBus from '@/services/eventBus';
import dayjs from "dayjs";
import IconButton from '@/components/IconButton.vue';
import FormSection from "../components/FormSection.vue";
import Transaction, { TransactionDefaultProps } from '../models/Transaction';
import TransactionItem, { TransactionItemDefaultProps } from '../models/TransactionItem';
import ValidationResult from '../models/ValidationResult';
import store, { TransactionStore } from "../services/TransactionStore";
import TransactionHeadEdit from "../components/TransactionHeadEdit.vue";
import TransactionItemEdit from '../components/TransactionItemEdit.vue';
import BookingTemplateLoadDialog from '../components/BookingTemplateLoadDialog.vue';
import TransactionItemDimensionEdit from '../components/TransactionItemDimensionEdit.vue';
import TransactionItemDimension, { TransactionItemDimensionDefaultProps } from '../models/TransactionItemDimension';
import auth from "../../../services/auth";
import ValidationError from "@/modules/downPayment/components/ValidationError.vue";
import http, { handleApiResponse } from "@/services/http";
import ApiResponse from "@/models/ApiResponse";
import UserSetting, {UserSettingDefaultProps} from "../models/UserSetting"
import GeneralLedgerApi from "@/modules/generalLedger/services/api";
import { CanModifyAccountsResult } from "@/modules/generalLedger/models/ModifyTransactionAccounts";
import { t } from "@/plugins/i18n";

// A Ctrl+Alt+nyilas navigáció cél-elemei (a v-tab role="tab"-ot és tabindex=0-t is beleértve).
// A tabindex="-1" elemek (pl. a k-grid-content) kimaradnak — lásd a navCells szűrését.
const NAV_FOCUSABLE = 'input:not([disabled]), textarea:not([disabled]), select:not([disabled]), button:not([disabled]), [role="tab"]:not(.v-tab--disabled), [tabindex="0"]';

const columns = [
        // {
        //   field: "id",
        //   title: " ",
        //   cell: "command",
        //   width: "120px"
        // },
        {
          field: "isHasDimensions",
          title: t("Transactions_Pontoz"),
          cell: "isHasDimensions",
          width: "150px",
          // locked: true,
        },     
        {
          field: "accNo",
          title: t("FokonyviSzam"),
          cell: "accNo",
          width: "150px",
        },
        {
          field: "total",
          title: t("Osszeg"),
          cell: "total",
          width: "130px"
        }, 
        {
          field: "dim1Code",
          title: t("Transactions_DimI"),
          cell: "dim1Code",
          width: "150px"
        },  
        {
          field: "dim2Code",
          title: t("Transactions_DimII"),
          cell: "dim2Code",
          width: "150px"
        },
        {
          field: "dim3Code",
          title: t("Transactions_DimIII"),
          cell: "dim3Code",
          width: "150px"
        },     
        {
          field: "car",
          title: "CAR",
          cell: "car",
          width: "135px"
        },   

        {
          field: "accDate",
          title: t("Transactions_GazdasagiEsDatuma"),
          cell: "accDate",
          width: "150px"
        },
        {
          field: "postCalc",
          title: t("Utokalkulacio"),
          width: "100px",
        },
        {
          field: "seqNumber",
          title: t("Transactions_FutoSorszam"),
          width: "100px"
        },
        {
          field: "prefix",
          title: t("Prefix"),
          width: "100px"
        },      
        {
          field: "bookType",
          title: t("Naplo"),
          cell: "bookType",
          width: "170px"
        },
        {
          field: "remark",
          title: t("Megjegyzes"),
          cell: "remark",
          width: "250px"
        },
        {
          field: "currency",
          title: t("Penznem"),
          cell: "currency",
          width: "85px"
        },
        {
          field: "currTotal",
          title: t("Transactions_OsszegDevizaban"),
          cell: "currTotal",
          width: "130px"
        }, 
        {
          field: "exchangeRate",
          title: t("Arfolyam"),
          cell: "exchangeRate",
          className: "right_text",
          width: "85px"
        }, 
        {
          field: "bookingDate",
          title: t("Transactions_KonyvekbeKerult"),
          type: "date",
          format: "{0: yyyy.MM.dd.}",
          headerClassName: "left_text",
          className: "right_text",
          width: "120px"
        },
        {
          field: "bookingUser",
          title: t("Ellenor"),
          width: "85px"
        },
        {
          field: "insDate",
          title: t("LetrehozasDatuma"),
          type: "date",
          format: "{0: yyyy.MM.dd.}",
          headerClassName: "left_text",
          className: "right_text",
          width: "150px"
        },
        {
          field: "user.name",
          title: t("Transactions_LetrehozottFelhasznalo"),
          width: "160px"
        },
        {
          field: "accSign",
          title: t("TetelTipus"),
          cell: "accSign",
          width: "85px"
        },

        // {
        //   field: "id",
        //   title: "Azonosító",
        //   // headerClassName: "center_text",
        //   className: "right_text",
        //   width: "85px"
        // },
        // {
        //   field: "dim1Code.id",
        //   title: "Dim. I",
        //   // headerClassName: "center_text",
        //   className: "right_text",
        //   width: "85px"
        // },
        // {
        //   field: "dim2Code.id",
        //   title: "Dim. II",
        //   // headerClassName: "center_text",
        //   className: "right_text",
        //   width: "85px"
        // },
        // {
        //   field: "dim3Code.id",
        //   title: "Dim. III",
        //   // headerClassName: "center_text",
        //   className: "right_text",
        //   width: "85px"
        // },
        // {
        //   field: "invoiceMirror.id",
        //   title: "Főkönyvi szám",
        //   // headerClassName: "center_text",
        //   className: "right_text",
        //   width: "120px"
        // },
        // {
        //   field: "period",
        //   title: "Periódus",
        //   // headerClassName: "center_text",
        //   className: "right_text",
        //   width: "85px"
        // },
        // {
        //   field: "",
        //   title: "Partner",
        //   cell:"partner",
        //   className: "right_text",
        //   width: "85px"
        // },
        // {
        //   field: "prcar",
        //   title: "PRCAR",
        //   // headerClassName: "center_text",
        //   className: "right_text",
        //   width: "85px"
        // },   

        {
          field: "invNo",
          title: t("Szamlaszam"),
          width: "110px"
        },
        // {
        //   field: "project",
        //   title: "Projekt",
        //   cell: 'projectID',
        //   width: "135px"
        // },

        {
          field: "project",
          title: t("ProjektNev"),
          cell: 'projectName',
          width: "150px"
        },
        {
          field: "project",
          title: t("Transactions_ProjektBelsoID"),
          cell: 'projectMainCode',
          width: "150px"
        },
        {
          field: "project",
          title: t("Transactions_ProjektKulsoID"),
          cell: 'projectCode',
          width: "150px"
        },
        
        {
          field: "productionNumber",
          title: t("MegrendelesSzam"),
          cell: "productionNumber",
          width: "160px"
        },
        {
          field: "productionExtCode",
          title: t("Transactions_MegrendelesVisszaigazolasa"),
          width: "185px"
        },
        {
          field: "workNumber",
          title: t("Transactions_MegrendelesMunkaszama"),
          width: "180px"
        },
        {
          field: "specDim1",
          title: t("Munkaszam"),
          cell: "specDim1",
          width: "110px"
        },
        {
          field: "specDim2",
          title: t("Gepjarmu"),
          cell: "specDim2",
          width: "110px"
        },
        {
          field: "specDim3",
          title: t("Szerelo"),
          cell: "specDim3",
          width: "110px"
        },
        {
          field: "specDim4",
          title: t("Szerviztipus"),
          cell: "specDim4",
          width: "110px"
        },
        // {
        //   field: "planId",
        //   title: "Gyártási szám",
        //   className: "right_text",
        //   // cell: "planId",
        //   width: "120px"
        // },
        {
          filterable: false,
          width: 0,
        }
]


interface Data {
  store: TransactionStore;
  editing: boolean;
  isAddAsd: boolean;
  paymentScheduleVisible: boolean;
  paymentScheduleVisible1: boolean;
  isMultiTableView: boolean;
  /** Alt+S: fókuszgyűrű a fókuszban lévő elemen (a Ctrl+Alt+nyilas navigáció követéséhez) */
  focusRing: boolean;
  isOrgMultiTableView: boolean;
  columns: any[];
  orgColumns: any[];
  statusChangeMode: boolean;

  focusMode: boolean;
  focusIndex: number;
  focusItems: any[];
  focusCopyItems: any[];
  /** A "Főkönyvi szám módosítás" backend-kapuja (can-modify). null = még nem kérdeztük le / nem releváns. */
  accnoModGate: CanModifyAccountsResult | null;
  /** Az az id, amire a saját kódunk épp navigál ÉS maga tölt újra – a route-watcher ezt nem tölti be másodszor. */
  pendingReloadId: number | null;
}

interface Methods {
  loadAccnoModGate(): Promise<void>;
  toggleAccnoEditMode(): Promise<void>;
  modifyAccounts(): Promise<void>;
  reloadTransaction(id: number): Promise<void>;
  addNewItem(accsign: string): void;
  copyItemFromSelected(item: TransactionItem): void;
  copyItemFromSelectedWithDimensions(item: TransactionItem): void;
  removeItem(item: TransactionItem): void;
  removeDimension(item: TransactionItemDimension): void;
  addNewDimension(accSign: string): void;
  copyDimensionFromSelected(to: string): void;
  save(): void;
  isCopyDisabled(selected: TransactionItemDimension, dimType: number, targetItem: TransactionItem ): boolean;
  hasSameItem(selectedDim: TransactionItemDimension, selectedItem: TransactionItem): boolean;
  makeCopyDimension(headId: number, copyDimension: TransactionItemDimension): void;
  applyReadOnlyState(): void;
  setStatus(e: number): void;
  undoChanges(): void;
  cancelAndBack(): void;
  columnReorder(columns: any): void;
  getUserSetting(controlName: string, type: string): Promise<UserSetting[]>;
  setUserSetting(controlName: string, type: string, userSetting: any, profileName: string, isDef: boolean): Promise<string>;
  validDate(date: any): boolean;
  handleHotKeys(e: KeyboardEvent): void;

  // Ctrl+Alt+nyilas navigáció (determinisztikus data-nav-row térkép)
  handleArrowNav(e: KeyboardEvent): void;
  navMove(key: string): void;
  navMoveVertical(currentRow: HTMLElement, delta: number, refX: number, rows: HTMLElement[]): void;
  navCrossLane(currentRow: HTMLElement, delta: number): void;
  navEnterRow(row: HTMLElement, delta: number, refX: number): boolean;
  navRows(): HTMLElement[];
  navCells(row: HTMLElement): HTMLElement[];
  navVisible(el: HTMLElement): boolean;
  navLaneOf(row: HTMLElement): string;
  navDistX(el: HTMLElement, refX: number): number;
  navFocusNearest(cells: HTMLElement[], refX: number): void;
  navGridMasterRows(gridEl: HTMLElement): HTMLElement[];
  navGridEditRow(gridEl: HTMLElement): HTMLElement | null;
  navGridStep(gridEl: HTMLElement, delta: number, refX: number): boolean;
  navGridSelectRow(tr: HTMLElement, refX: number): void;
  navFocusRowCell(tr: HTMLElement, refX: number, attempts: number): void;
  canChangeStatus(target: any, current: any, isReadOnly: boolean): boolean;
  onRegister(el: any): void;
  isTransactionModified(): boolean;
  switchTableView(): void;
}

interface Computed{
  isDisabledToPositive: boolean;
  isDisabledToNegative: boolean;
  isInSameDimension: boolean;
  arrayToPositive: TransactionItemDimension[];
  arrayToNegative: TransactionItemDimension[];
  error: string;
  warning: string;
  isChangesHappend: boolean;
  canLoadTemplate: boolean;
  loadTemplateBlockedReason: string;
  pageTitle: string;
  canModifyAccounts: boolean;
  accnoModCanReverse: boolean;
  accnoModReverseBlockedReason: string;
  accnoChangeCount: number;
  canRunAccnoMod: boolean;
  accnoModHint: string;
  saveHint: string;
}

export default Vue.extend<Data, Methods, Computed, {}>({
  components: {
    IconButton,
    FormSection,
    TransactionHeadEdit,
    TransactionItemEdit,
    TransactionItemDimensionEdit,
    ValidationError,
    BookingTemplateLoadDialog
  },

  data() {
    return {
      store,
      editing: false,
      isAddAsd: false,
      paymentScheduleVisible: true,
      paymentScheduleVisible1: true,
      isMultiTableView: true,
      isOrgMultiTableView: true,
      focusRing: false,
      columns: columns,
      orgColumns: columns,
      statusChangeMode: false,
      focusMode: false,
      focusIndex: 0,
      focusItems: [],
      focusCopyItems: [],
      accnoModGate: null,
      pendingReloadId: null,
    }
  },

  beforeMount() {
    window.addEventListener('keydown', this.handleHotKeys);
    // CAPTURE fázis kell: bubble-ben a Vuetify v-select/autocomplete a nyílra már menüt nyitna,
    // mire a mi kezelőnk sorra kerül. (A remove-nál is kötelező a true!)
    window.addEventListener('keydown', this.handleArrowNav, true);
  },
  async mounted() {
    // A tranzakció betöltése + readonly derivált ELŐSZÖR, egyetlen sorrendezett folyamatban.
    // (Korábban ez async beforeMount-ban volt, de a Vue NEM várja meg az async beforeMount-ot,
    //  így a mounted-del PÁRHUZAMOSAN futott — F5-nél a "Sablon betöltése" gomb feltétele néha
    //  féligbetöltött store-ra értékelődött ki, és eltűnt a gomb. Az adatbetöltés minden
    //  ágon tovább fut, nincs korai return.)
    // A create route-on nincs :id param (NaN lenne) — ott nem töltünk, a store a
    // TransactionDefaultProps-on marad, amíg a lenti create-ág nem inicializálja.
    // (loadTransaction(NaN) a szerverről null-t hozott → transaction=null → render-error.)
    // Fázis 1: a fej + státusz-derivált + nézetbeállítás a teljes-képernyős BusyIndicator
    // overlay alatt tölt (gyors); a finally hibánál is leveszi.
    eventBus.$emit("busy-message", true);
    try {
      const routeId = Number(this.$route.params.id);
      if (routeId > 1) {
        // Pesszimista kezdőérték: a store singleton, így az await alatt még az ELŐZŐLEG
        // nyitott tranzakció státusza ül bent — enélkül egy lekönyvelt tranzakció feje
        // egy pillanatra szerkeszthetőnek renderelődhetne.
        this.store.isReadOnlyView = true;
        await this.store.loadTransaction(routeId);
      } else {
        // A store singleton: az előzőleg nyitott tranzakció feje bent maradna (id > 1),
        // amitől a "Sablon betöltése" gomb és a fej-űrlap átmenetileg a régi adatot mutatná.
        this.store.transaction = { ...TransactionDefaultProps };
      }

      this.applyReadOnlyState();
      await this.loadAccnoModGate();

      const responseTableView = await this.getUserSetting("LEDGER_TRANSACTION_TABLE_VIEW","Visibility");
      if(responseTableView.length > 0){
        this.isMultiTableView = JSON.parse(responseTableView[0].userSetting).value
        this.isOrgMultiTableView = this.isMultiTableView
      }

      // const responseGridView = await this.getUserSetting("LEDGER_TRANSACTION_GRID_VIEW","Gridview");
      // if(responseGridView.length > 0){
      //   this.columns = JSON.parse(responseGridView[0].userSetting).value;
      //   this.orgColumns = this.columns;
      // }
    } finally {
      eventBus.$emit("busy-message", false);
    }

    const id = Number(this.$route.params.id);
    const isEdit = id > 1 && this.$route.name == "TransactionEdit";
    const baseLoads = [
      this.store.loadBookTypes(),
      this.store.loadCurrencies(),
      this.store.loadTransStats(),
      this.store.loadTransTypes(),
      this.store.loadSerCars(),
      this.store.loadProjectHeads(),
      this.store.loadPOs(),
      this.store.loadStations(),
      this.store.loadUsers(),
      this.store.loadTools(),
      this.store.loadAccGroup(),
    ];

    this.editing = isEdit;

    // Fázis 2: a tételek + dimenziók + törzsadatok betöltése már nem teljes-képernyős overlay,
    // hanem a tétel/dimenzió gridekre tett k-loading-mask alatt fut (store.isItemsLoading) —
    // a fej azonnal látható, a gridek pedig egyértelmű "töltés alatt" állapotot mutatnak.
    this.store.isItemsLoading = true;
    try {
      if (isEdit) {
        // await this.store.loadTransaction(id);

        const accDateLoad = [
          this.store.loadPeriods(this.store.transaction.accDate),
          this.store.loadDimensions(this.store.transaction.accDate),
          this.store.loadInvoiceMirrors(this.store.transaction.accDate),
        ]

        await this.store.loadTransactionItems(id);

        this.store.selectedItem = this.store.transactionItems.filter(x => x.accSign === "T")[0]?? {...TransactionItemDefaultProps};
        this.store.negativeSelectedItem = this.store.transactionItems.filter(x => x.accSign === "T")[0]?? {...TransactionItemDefaultProps};
        this.store.positiveSelectedItem = this.store.transactionItems.filter(x => x.accSign === "K")[0]?? {...TransactionItemDefaultProps};

        await this.store.loadTransactionDimensions(this.store.transactionItems.map(item => item.id));
        await Promise.all([...baseLoads, ...accDateLoad]);

      } else {

        if(this.$route.name == "TransactionCreate"){

          this.store.transaction = { ...TransactionDefaultProps };
          this.store.transaction.type = true;
          this.store.transaction.accDate = dayjs().format("YYYY-MM-DD");
          this.store.transaction.userId = auth.userID;
          this.store.transaction.userName = auth.userName;

          const accDateLoad = [
            this.store.loadPeriods(this.store.transaction.accDate),
            this.store.loadDimensions(this.store.transaction.accDate),
            this.store.loadInvoiceMirrors(this.store.transaction.accDate),
          ]

          await Promise.all([...baseLoads, ...accDateLoad]);

          const period = this.store.periods.find(
            x =>
              new Date(x.startDate) <= new Date(this.store.transaction.accDate) &&
              new Date(x.endDate) >= new Date(this.store.transaction.accDate)
          );
          this.store.transaction.periodName = period?.period;

        }else{
          await this.store.loadTransaction(id);
          this.store.transaction.id = 1;

          const accDateLoad = [
            this.store.loadPeriods(this.store.transaction.accDate),
            this.store.loadDimensions(this.store.transaction.accDate),
            this.store.loadInvoiceMirrors(this.store.transaction.accDate),
          ];

          await Promise.all([...baseLoads, ...accDateLoad]);
          if(this.$route.query.mode == "full"){
            await this.store.loadTransactionItems(id);

            this.store.selectedItem = this.store.transactionItems.filter(x => x.accSign === "T")[0]?? {...TransactionItemDefaultProps};
            this.store.negativeSelectedItem = this.store.transactionItems.filter(x => x.accSign === "T")[0]?? {...TransactionItemDefaultProps};
            this.store.positiveSelectedItem = this.store.transactionItems.filter(x => x.accSign === "K")[0]?? {...TransactionItemDefaultProps};

            await this.store.loadTransactionDimensions(this.store.transactionItems.map(item => item.id));

            this.store.transactionItems.forEach(item => {
                const itemDimension = store.transactionItemsDimensions.filter(x=> x.head == item.id)
                itemDimension.forEach(dimension =>{
                  dimension.id = 0;
                  dimension.head = 0;
                  item.newTransactionItemDimensions.push(dimension)
                })
                item.id = 0;
                item.insDate = new Date();
                this.store.newItems.push(item);
            });
          }
        }

        this.store.transaction.insDate = dayjs().format("YYYY-MM-DD");
        // A számszerű status-t IS 2-re állítjuk (nem csak a statusName feliratot) — másolásnál a
        // forrás eredeti státusza (pl. 5 = "Könyvekben szerepel") enélkül megragadt volna a
        // store.transaction.status mezőben, és a TransactionHeadEdit saját "editing" computed-je
        // (status > 3) emiatt tiltottnak mutatta a fej mezőit (Gazdasági esemény, Megjegyzés stb.)
        // egy elvileg teljesen szerkeszthető, mentetlen másolatnál.
        this.store.transaction.status = 2;
        this.store.transaction.statusName = t("ElokeszitesAlatt");
        this.store.transaction.typeName = t("Manualis");
      }
    } finally {
      this.store.isItemsLoading = false;
    }
  },
  async beforeDestroy(){
    this.store.transactionItems = [];
    this.store.transactionItemsDimensions = [];

    this.store.selectedItem = {...TransactionItemDefaultProps};
    this.store.negativeSelectedItem = {...TransactionItemDefaultProps};
    this.store.positiveSelectedItem = {...TransactionItemDefaultProps};

    this.store.selectedDimension = {...TransactionItemDimensionDefaultProps};
    this.store.negativeSelectedDimension = {...TransactionItemDimensionDefaultProps};
    this.store.positiveSelectedDimension = {...TransactionItemDimensionDefaultProps};

    this.store.newItems = [];
    this.store.modifiedItems = [];
    this.store.deletedItems = [];

    this.store.newDimensions = [];
    this.store.modifiedDimensions = [];
    this.store.deletedDimensions = [];

    this.store.isReadOnlyView = false;
    this.store.isAccnoEditMode = false;
    this.store.accnoChanges = {};
    this.store.accnoModMirrors = [];
    this.store.accnoModReverse = true;
    this.store.selectedInvNoGroup = 1;

    window.removeEventListener('keydown', this.handleHotKeys);
    window.removeEventListener('keydown', this.handleArrowNav, true);
  },

  methods: {
    addNewItem(accsign){
        const item = JSON.parse(JSON.stringify(TransactionItemDefaultProps));
        item.id = 0;
        item.accDate = store.transaction.accDate
        if(accsign != '')
          item.accSign = accsign == "K" ? "K" : "T";
        else{
          item.accSign = '';
        }
        item.trans = this.store.transaction.id;
        item.partner = this.store.transaction.partner;
        // K2D d_g_ixboktrans: az inv_no oszlop initial="1" – minden új sor pontozatlanul (1) indul,
        // NEM kap egyedi, növekvő azonosítót. A korábbi maxValue+1 kód minden új tételnek saját,
        // másokétól különböző inv_no-t adott, ami miatt két frissen felvett tétel a Pontoz pipával
        // SOHA nem tudott egy csoportba kerülni (az onPairChange csak invNo==1-ről nyit új csoportot).
        item.user = {id:auth.userID, name:auth.userName};
        const matchingPeriod = store.periods.filter((x) => x.period == (String(item.accDate).split("-")[0]+ String(item.accDate).split("-")[1]))[0] as any;
        if(!matchingPeriod){
          eventBus.$emit("error", t("Transactions_NincsAGazdasagiEsemenyDatumahozTartozo"));
          return;
        }
        item.period = matchingPeriod.id;
        this.store.transactionItems.unshift(item);
        this.store.newItems.push(item);
        accsign == "K" ? this.store.positiveSelectedItem = item : this.store.negativeSelectedItem = item ;
        this.store.selectedItem = item;
    },
    copyItemFromSelected(item){
      const newItem = JSON.parse(JSON.stringify(item))
      newItem.id = 0;
      newItem.insDate = new Date()
      // A JSON-klónozás a forrás tétel newTransactionItemDimensions tömbjét (a mentetlen tételekhez
      // tartozó, még el nem mentett dimenzió-sorokat) IS átmásolja — ez a gomb viszont kifejezetten
      // a dimenziók NÉLKÜLI másolásra való, ezért ürítjük.
      newItem.newTransactionItemDimensions = [];
      this.store.transactionItems.unshift(newItem);
      this.store.newItems.push(newItem);
      this.store.selectedItem = newItem;
    },
    copyItemFromSelectedWithDimensions(item){

      const newItem = JSON.parse(JSON.stringify(item))
      newItem.id = 0;
      newItem.insDate = new Date();
      newItem.newTransactionItemDimensions = [];
      this.store.transactionItems.unshift(newItem);
      this.store.newItems.push(newItem);
      this.store.selectedItem = newItem;

      const itemDimension = item.id > 0
        ? store.transactionItemsDimensions.filter(x=> x.head == item.id)
        : item.newTransactionItemDimensions;

      itemDimension.forEach(element => {
        const dimension = JSON.parse(JSON.stringify(element));
        dimension.id = 0;
        dimension.head = 0;
        newItem.newTransactionItemDimensions.push(dimension);
        this.store.transactionItemsDimensions.push(dimension);
      });
    },
    removeItem(item){
      this.store.transactionItems = this.store.transactionItems.filter((i: TransactionItem) => i!== item);
      if(item.id === 0){ 
        this.store.newItems = this.store.newItems.filter((i: TransactionItem) => i !== item)
      }
      else{
        this.store.deletedItems.push(item.id);
      }
    },
    removeDimension(item){
      this.store.transactionItemsDimensions = this.store.transactionItemsDimensions.filter((i: TransactionItemDimension) => i!== item);
      if(item.id === 0){
        this.store.newDimensions = this.store.newDimensions.filter((i: TransactionItemDimension) => i !== item)
      }
      else{
        this.store.deletedDimensions.push(item.id);
      }
    },
    addNewDimension(accSign){
      const isNegative = accSign === "T";
      const selectedItem = isNegative 
        ? this.store.negativeSelectedItem 
        : this.store.positiveSelectedItem;

      const dimCodeType = Number(
        isNegative 
          ? this.store.negativeSelectedDimCodeType 
          : this.store.positiveSelectedDimCodeType
      );
      const dimension = JSON.parse(JSON.stringify(TransactionItemDimensionDefaultProps));
      dimension.head = selectedItem.id;
      dimension.dimCodeType = dimCodeType;
      // const dimension = {
      //   ...TransactionItemDimensionDefaultProps,
      //   head: selectedItem.id,
      //   dimCodeType
      // };

      this.store.transactionItemsDimensions.unshift(dimension);
      this.store.selectedDimension = dimension;

      if (dimension.head === 0) {
        selectedItem.newTransactionItemDimensions.push(dimension);
      } else {
        this.store.newDimensions.push(dimension);
      }
    },
    makeCopyDimension(headId, copyDimension){
        const dimension = JSON.parse(JSON.stringify(copyDimension));
        dimension.id = 0;
        dimension.head = headId
        this.store.transactionItemsDimensions.unshift(dimension);
        this.store.newDimensions.push(dimension);
    },
    copyDimensionFromSelected(to){
      if(to == "K"){
        this.makeCopyDimension(store.positiveSelectedItem.id,store.negativeSelectedDimension)
      }else{
        this.makeCopyDimension(store.negativeSelectedItem.id,store.positiveSelectedDimension)
      }
    },
    async save(){
      if(this.error != ""){
        eventBus.$emit("error", t("Transactions_AMentesNemVegezhetoElMivel"));
        return
      }
      else if(store.isReadOnlyView){
        eventBus.$emit("error", t("Transactions_AMentesNemVegezhetoElMivel_2"));
        return
      }


      let isModificationHappend = false;

      if(this.isOrgMultiTableView != this.isMultiTableView){
        const resp = await this.setUserSetting("LEDGER_TRANSACTION_TABLE_VIEW","Visibility",this.isMultiTableView,"MultiTableView",false);
        if(resp == "success"){
          this.isOrgMultiTableView = this.isMultiTableView;
        }
        isModificationHappend = true;
      }

      if(this.isTransactionModified()){
        this.store.transaction.isMod = true;
      }
      

      const ret = await this.store.saveTransaction(this.store.transaction.id);
      if( ret > 1){
        // Új (id=1) fej sikeres mentése önmagában is módosítás: e nélkül tétel nélküli
        // create-nél "Nem történt módosítás" jönne, nem navigálnánk át az edit/:id-re,
        // és a "Sablon betöltése" gomb sem jelenne meg (K2D flow: fej mentése -> sablon betöltés).
        if(this.store.transaction.id == 1){
          isModificationHappend = true;
        }
        if(this.store.newItems.length > 0){
          if(this.store.transaction.id == 1){
            this.store.newItems.forEach(el => {
              el.trans = ret;
            })
          }
          await this.store.saveTransactionItems();
          isModificationHappend = true;
        }
      }

      //Adatbázis műveletek - Tranzakció tételek
      if(this.store.modifiedItems.length > 0){
        await this.store.updateTransactionItems();  
        isModificationHappend = true;
      }
      
      if(this.store.deletedItems.length > 0){
        await this.store.deleteTransactionItems();
        isModificationHappend = true;
      }

  

      // Adatbázis müveletek - Dimenziók
      if(this.store.newDimensions.length > 0){
        await this.store.saveTransactionDimensionItems();
        isModificationHappend = true;
      }
        
      if(this.store.modifiedDimensions.length > 0){
        await this.store.updateTransactionDimensionItems();
        isModificationHappend = true;
      }
      
      if(this.store.deletedDimensions.length > 0){
        await this.store.deleteTransactionDimensionItems();
        isModificationHappend = true;
      }
      

      if (isModificationHappend) {
        eventBus.$emit("success", t("SikeresMentes"));

        this.store.deletedItems = [];
        this.store.newItems = [];
        this.store.modifiedItems = [];

        this.store.deletedDimensions = [];
        this.store.newDimensions = [];
        this.store.modifiedDimensions = [];

        if (this.$route.fullPath !== `/transactions/edit/${ret}`) {
          this.$router.push(`/transactions/edit/${ret}`);
        }
        else {
          await this.store.loadTransactionItems(ret);
        }
      }
      else {
        eventBus.$emit("warn", t("Transactions_NemTortentModositas"));
      }

    },
    hasSameItem(selectedDim,selectedItem){
      if(selectedDim.dimCode <= 1){ // nincs kiválasztott (kódolt) elem az oldalon — új, mentetlen sornál az id==0 volna, ezért a dimCode a teszt
        return true
      }

      const array = this.store.transactionItemsDimensions.filter(
        x =>
          x.head == selectedItem.id &&
          x.dimCodeType == selectedDim.dimCodeType
      );

      return array.some(i => i.dimCode == selectedDim.dimCode);
    },
    isCopyDisabled(selected,dimType,targetItem){
      return (
        store.positiveSelectedDimCodeType !== store.negativeSelectedDimCodeType ||
        selected.id === 0 ||
        store.transactionItemsDimensions.some(
          x =>
            x.head === targetItem.id &&
            x.dimCodeType === dimType &&
            x.dimCode === selected.dimCode
        )
      );
    },
    // --- Főkönyvi szám módosítás (K2D Javítás -> accno_mod) ---
    // A kapuzó lekérdezés CSAK könyvelt (status 5) tranzakciónál fut le – máshol felesleges kérés lenne.
    async loadAccnoModGate(){
      this.accnoModGate = null;
      if (this.store.transaction.id <= 1 || this.store.transaction.status !== 5) return;
      try {
        this.accnoModGate = await GeneralLedgerApi.CanModifyAccounts(this.store.transaction.id);
      } catch {
        // A gomb ilyenkor egyszerűen nem jelenik meg – a hibát a globális kezelő már jelezte.
        this.accnoModGate = null;
      }
    },
    async toggleAccnoEditMode(){
      if (this.store.isAccnoEditMode) {
        // Kilépés: a csak megjelenítés szintjén átírt főkönyvi számokat a szerverről töltjük vissza.
        this.store.isAccnoEditMode = false;
        this.store.accnoChanges = {};
        await this.undoChanges();
        return;
      }

      eventBus.$emit("busy-message", true);
      try {
        // A választó SZŰKÍTETT listája (csak könyvelésre nyitott, kézi, nem fixált kontírszám – K2D w_popup_accno).
        const year = new Date(this.store.transaction.accDate).getFullYear();
        this.store.accnoModMirrors = await GeneralLedgerApi.GetInvoiceMirrorsByYear(year, true);
        this.store.accnoChanges = {};
        // Kézinél a sztornó alapból be, de csak ha egyáltalán lehetséges.
        this.store.accnoModReverse = this.accnoModCanReverse;
        this.store.isAccnoEditMode = true;
      } finally {
        eventBus.$emit("busy-message", false);
      }
    },
    async modifyAccounts(){
      const lines = Object.keys(this.store.accnoChanges).map(key => ({
        itemId: Number(key),
        newAccnoId: this.store.accnoChanges[Number(key)],
      }));

      eventBus.$emit("busy-message", true);
      try {
        const res = await GeneralLedgerApi.ModifyTransactionAccounts({
          transactionId: this.store.transaction.id,
          lines,
          // Gépinél a backend úgyis kötelezően sztornóz; kézinél a kapcsoló dönt.
          reverseOriginal: this.store.transaction.type ? this.store.accnoModReverse : true,
          // A "változatlan másolás" eset a szerkesztőben értelmetlen, az a régi képernyőn maradt.
          allowCopyUnchanged: false,
        });

        if (!res || !res.success) {
          eventBus.$emit("error", (res && res.message) || t("Transactions_AFokonyviSzamokAtvezeteseNemSikerult"));
          return;
        }

        eventBus.$emit("success", res.message);
        this.store.isAccnoEditMode = false;
        this.store.accnoChanges = {};
        // Az új (javított) tranzakcióra váltunk: kézinél 2-es (szerkeszthető), gépinél 5-ös (read-only).
        // A pendingReloadId jelzi a route-watchernek, hogy ezt az id-t MI töltjük be – különben a push
        // után a watcher is elindítana egy párhuzamos újratöltést (dupla load, villogó loading-mask,
        // és a Mentés gomb a versenyhelyzet közepén tiltva maradhat).
        this.pendingReloadId = res.transId;
        this.$router.push(`/transactions/edit/${res.transId}`);
        await this.reloadTransaction(res.transId);
      } finally {
        eventBus.$emit("busy-message", false);
      }
    },
    // Teljes újratöltés egy MÁSIK tranzakcióra. Azért kell, mert az /edit/A -> /edit/B navigáció ugyanazt a
    // route-rekordot találja el: a komponens nem mountol újra, tehát a mounted betöltése sem fut le.
    async reloadTransaction(id: number){
      await this.store.loadTransaction(id);   // ez állítja át a store.transaction.id-t is
      await this.undoChanges();               // erre az id-re tölti a tételeket + dimenziókat
      this.applyReadOnlyState();
      await this.loadAccnoModGate();
    },
    // A státusz → szerkeszthetőség levezetés. Mountkor ÉS minden státuszváltás után lefut,
    // különben a mezők a betöltéskori állapotukban ragadnának (3→2 után is zárva maradtak,
    // 2→3 után pedig nyitva; csak F5 javította).
    // K2D w_resp_trans: szerkeszteni CSAK status=2-t lehet; a "Könyvekben szerepel" (5) is
    // read-only (user-döntés 2026-08-10, a korábbi részleges-szerkesztés ág kivéve) — az 5-ös
    // dim/projekt/fksz módosítás külön funkció (másolás+sztornó), nem az editor dolga.
    applyReadOnlyState(){
      // Új / másolt tranzakció mindig szerkeszthető (nincs :id, vagy id <= 1). Meglévőnél
      // KIZÁRÓLAG a fej státusza dönt — nincs külön megtekintés-útvonal és nincs átirányítás.
      // FONTOS: a /transactions/copy/:id route-paraméter a FORRÁS tranzakció azonosítója, nem a
      // leendő (még mentetlen, id=1) másolaté — enélkül egy "Könyvekben szerepel" (vagy más
      // read-only státuszú) forrásból készült másolat is olvashatóvá/menthetetlenné vált volna.
      const id = Number(this.$route.params.id);
      const isCopyRoute = this.$route.name === "TransactionCopy";
      this.store.isReadOnlyView = !isCopyRoute && id > 1 && [3, 4, 5, 6].includes(this.store.transaction.status);
    },
    async setStatus(status: number){
      if(this.isChangesHappend){
        eventBus.$emit("error", t("Transactions_KerjukMentseAModositasokatAzAllapot"));
        return;
      }
      eventBus.$emit("busy-message", true);
      try {
        const response = await http.post<ApiResponse<ValidationResult[]>>(`general-ledger-transaction/set/status/${status}`, { selectedLedgers: [this.store.transaction] }).then(handleApiResponse);
        if(response.length > 0){
          response.forEach(mess =>{
            if(mess.isValid){
              eventBus.$emit("success", mess.message);
            }
            else{
              eventBus.$emit("error", mess.message);
            }
          })
        }
        await this.store.loadTransaction(Number(this.$route.params.id));
        // Az új státuszhoz tartozó szerkeszthetőség azonnal érvényesüljön (F5 nélkül)
        this.applyReadOnlyState();
        // A "Főkönyvi szám módosítás" gomb feltétele is státusz-függő (csak 5-nél él).
        await this.loadAccnoModGate();
      } finally {
        eventBus.$emit("busy-message", false);
      }
    },
    // Mégse gomb: az eddigi (nem mentett) módosítások eldobása és visszanavigálás a hívó oldalra.
    // (Az undoChanges marad a sablon-betöltés utáni helyben-újratöltésnek.)
    cancelAndBack(){
      store.modifiedTransaction = [];
      store.modifiedItems = [];
      store.newItems = [];
      store.deletedItems = [];
      store.modifiedDimensions = [];
      store.newDimensions = [];
      store.deletedDimensions = [];
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.push("/transactions");
      }
    },
    async undoChanges(){
      // Mégse / sablon betöltés után ugyanaz a fej + tétel + dimenzió újratöltés fut,
      // mint mountkor — a gridekre tett k-loading-mask (isItemsLoading) fedi.
      this.store.isItemsLoading = true;
      try {
        await this.store.loadTransaction(this.store.transaction.id);
        store.modifiedTransaction = [];

        await this.store.loadTransactionItems(this.store.transaction.id);
        store.modifiedItems = [];
        store.newItems = [];
        store.deletedItems = [];

        this.store.selectedItem = this.store.transactionItems.filter(x => x.accSign === "T")[0]?? {...TransactionItemDefaultProps};
        this.store.negativeSelectedItem = this.store.transactionItems.filter(x => x.accSign === "T")[0]?? {...TransactionItemDefaultProps};
        this.store.positiveSelectedItem = this.store.transactionItems.filter(x => x.accSign === "K")[0]?? {...TransactionItemDefaultProps};
        this.store.selectedInvNoGroup = 1;

        await this.store.loadTransactionDimensions(this.store.transactionItems.map(item => item.id));
        store.modifiedDimensions = [];
        store.newDimensions = [];
        store.deletedDimensions = [];
      } finally {
        this.store.isItemsLoading = false;
      }
    },
    columnReorder(columns){
      this.columns = columns;
    },
    async getUserSetting(contName,type){
      const setting: UserSetting = {...UserSettingDefaultProps, userId: auth.userID, controlName: contName, type: type}
      return await this.store.loadUserSetting(setting);
    },
    async setUserSetting(contName,type,userSet,profName,isDef){
      const setting: UserSetting = {...UserSettingDefaultProps, userId: auth.userID, controlName: contName, type: type, userSetting: JSON.stringify({value: userSet}), profileName: profName, isDefault: isDef}
      return await this.store.setUserSetting(setting);
    },
    validDate(date){
      const baseDate = new Date(store.transaction.accDate);
      const d = new Date(date);
    
      const year = baseDate.getFullYear();
      const month = baseDate.getMonth();

      const start = new Date(year, month, 1);
      const end = new Date(year, month + 1, 0);


      return d >= start && d <= end;
    },
    canChangeStatus(target, current, isReadOnly) {
      // K2D w_resp_trans pb_stat5: a "Könyvekben szerepel" (5) CSAK Ellenőrizve (4) állapotból
      // érhető el (ld. a gomb :disabled feltételét) — ez a szabály FÜGGETLEN az alábbi, a többi
      // célállapotra vonatkozó "read-only, kivéve a 3-as státuszt" kivételtől (a 4-es állapot maga
      // is read-only, tehát a blanket guard alá esve tévesen letiltaná a gyorsbillentyűs utat is).
      if (target === 5) return current === 4

      if (isReadOnly && current !== 3) return false

      if (target === 2) return !(current === 2 || current === 6)
      if (target === 3) return current < 3
      if (target === 4) return !(current >= 4 || current === 2)
      if (target === 6) return !(current >= 6 || [4,5].includes(current))

      return false
    },
    handleHotKeys(e){
      if (e.ctrlKey && e.key === 's') {
        e.preventDefault();
        this.save();
        return;
      }
      if(e.altKey && e.key === 'v'){
        e.preventDefault();
        if(this.focusMode){
          this.focusMode = false
          eventBus.$emit("error", t("Transactions_UjElemHozzadasKikapcsolva"));
        }
        this.isMultiTableView = !this.isMultiTableView;
        return;
      }  

      // Alt+G (gyűrű) — az Alt+S-t a user gépén valami elfogta (Chrome/Edge alatt élő tesztben
      // működött, nála mégsem), ezért került át. Az e.code is kell: magyar kiosztáson a JOBB Alt
      // (AltGr) + betű más karaktert ad e.key-ben, a fizikai billentyűt csak a code azonosítja.
      if(e.altKey && (e.key === 'g' || e.code === 'KeyG')){
        e.preventDefault();
        this.focusRing = !this.focusRing;
        eventBus.$emit(this.focusRing ? "success" : "error", this.focusRing ? t("Transactions_FokuszgyuruBekapcsolva") : t("Transactions_FokuszgyuruKikapcsolva"));
        return;
      }

      if(e.altKey && e.key === 'n'){
        e.preventDefault();
        // A store.isReadOnlyView-t a +/másolás gombok :disabled feltétele már figyeli — enélkül a
        // mód "aktívnak" mutatta magát (sikeres toast, gombok közti fókusz-léptetés) egy olyan
        // státuszban is, ahol a mögötte álló gombok úgysem csinálnak semmit kattintásra/Enterre.
        if(this.store.isReadOnlyView){
          eventBus.$emit("error", t("Transactions_EbbenAStatuszbanATranzakcioNem"));
          return;
        }
        this.focusMode = true
        this.focusIndex = 0;

        if(this.isMultiTableView){
          this.focusCopyItems = this.focusItems.filter((_,i) => ![0,1,2].includes(i))
        }else{
          this.focusCopyItems = this.focusItems.filter((_,i) => ![3,4,5,6,7,8].includes(i))
        }

        this.$nextTick(() => {
          this.focusCopyItems[this.focusIndex].$el?.focus()
        })
        eventBus.$emit("success", t("Transactions_UjElemHozzadasAktiv"));
        return;
      }
      if(this.focusMode){
        if(e.key === "Tab"){

          e.preventDefault()
          if (e.shiftKey) {
            this.focusIndex--
          } else {
            this.focusIndex++
          }

          if (this.focusIndex < 0) this.focusIndex = this.focusCopyItems.length-1
          if (this.focusIndex > this.focusCopyItems.length-1) this.focusIndex = 0

          this.focusCopyItems[this.focusIndex].$el?.focus()
          
          return
        }
        if(e.key === "Escape" || e.key === 'Enter'){
            this.focusMode = false
            eventBus.$emit("error", t("Transactions_UjElemHozzadasKikapcsolva"));
            return
        }
      }
      if(e.altKey && e.key === 'a'){
        e.preventDefault();
        this.statusChangeMode = true;
        eventBus.$emit("success", t("Transactions_StatuszModValtasAktiv"));
        return
      }
      if(this.statusChangeMode){
        const statusMap = {
          '1': 2,
          '2': 3,
          '3': 4,
          '4': 5,
          '5': 6
        }

        const target = statusMap[e.key as keyof typeof statusMap]
        const current = store.transaction.status
        const isReadOnly = store.isReadOnlyView

        if (!target) {
          this.statusChangeMode = false
          eventBus.$emit("error", t("Transactions_StatuszModValtasKikapcsolva"))
          return
        }

        if (!this.canChangeStatus(target, current, isReadOnly)) {
          eventBus.$emit("error", t("Transactions_StatuszAllitasNemLehetseges"))
          return
        }

        this.setStatus(target)
        this.statusChangeMode = false
        eventBus.$emit("error", t("Transactions_StatuszModValtasKikapcsolva"))
      }

      if(!e.ctrlKey && e.altKey && (e.key == 'ArrowDown' || e.key == 'ArrowUp' || e.key == 'ArrowRight' || e.key == 'ArrowLeft')){
        
        const selectedItem = store.selectedItem;
        let actualList = [];
        if(this.isMultiTableView){
          actualList = store.transactionItems.filter(x => x.accSign == store.selectedItem.accSign);
          if(e.key == 'ArrowRight'){
            e.preventDefault();
            const rightList = store.transactionItems.filter(x => x.accSign == "K");

            if(store.selectedItem.accSign != "K" && rightList.length != 0){
              if(rightList[actualList.indexOf(selectedItem)] !== undefined){

                store.selectedItem = rightList[actualList.indexOf(selectedItem)]
              }else{
                store.selectedItem = rightList[rightList.length-1]
              }
            }

          }else if(e.key == 'ArrowLeft'){
            e.preventDefault();
            const leftList = store.transactionItems.filter(x => x.accSign == "T");
            if(store.selectedItem.accSign != "T" && leftList.length != 0){
              if(leftList[actualList.indexOf(selectedItem)] !== undefined){
  
                
                store.selectedItem = leftList[actualList.indexOf(selectedItem)]
              }else{
                store.selectedItem = leftList[leftList.length-1]
              }
            } 
          }
        }
        else{
          actualList = store.transactionItems;
        }
        
        let actualIndex = actualList.indexOf(selectedItem)
        if(e.key == 'ArrowDown'){
          actualIndex == actualList.length-1 ? actualIndex : actualIndex++
          store.selectedItem = actualList[actualIndex];
        }else if(e. key == 'ArrowUp'){
          actualIndex == 0 ? actualIndex : actualIndex--
          store.selectedItem = actualList[actualIndex];
        }

      }
    },

    // ===== Ctrl+Alt+nyilas navigáció =====
    // Determinisztikus sor/cella-térkép a data-nav-row jelölésekből (NEM geometriai keresés —
    // a korábbi Alt+nyilas kísérlet ezen bukott el). Geometria csak a cellaválasztásnál van:
    // a célsor cellái közül a vízszintesen legközelebbi kapja a fókuszt (oszloptartás).
    // Hasáb-szabály (user-döntés): ↑/↓ a saját hasábban (data-nav-lane) marad, a ←/→ a sor
    // szélén átlép a másik hasáb azonos indexű sorába. Gridben a ↑/↓ a sor-kijelölést lépteti.
    handleArrowNav(e) {
      if (!e.ctrlKey || !e.altKey || e.shiftKey || e.metaKey) return;
      if (!['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key)) return;
      e.preventDefault();
      e.stopPropagation();
      this.navMove(e.key);
    },

    navMove(key) {
      const root = this.$el as HTMLElement;
      const rows = this.navRows();
      if (!rows.length) return;

      const active = document.activeElement as HTMLElement | null;
      const focusEl = active && root.contains(active) ? active : null;
      const currentRow = focusEl ? (focusEl.closest('[data-nav-row]') as HTMLElement | null) : null;
      const refX = focusEl ? this.navDistX(focusEl, 0) : 0; // navDistX(., 0) = az elem közép-x-e

      if (!currentRow || !rows.includes(currentRow)) {
        // Nincs fókusz a térképen: belépés az első (↑-nál az utolsó) használható sorra.
        const entry = key === 'ArrowUp' ? [...rows].reverse() : rows;
        const delta = key === 'ArrowUp' ? -1 : 1;
        for (const row of entry) if (this.navEnterRow(row, delta, refX)) return;
        return;
      }

      const isGrid = currentRow.dataset.navRow === 'grid';

      if (key === 'ArrowLeft' || key === 'ArrowRight') {
        const delta = key === 'ArrowRight' ? 1 : -1;
        // Gridben a vízszintes lépés annak a sornak a mezői közt megy, amelyikben a fókusz áll
        // (nyitott törlés-megerősítő detail-sorban a Megerősítés/Mégse gombok közt is).
        const editRow = isGrid
          ? (((focusEl && focusEl.closest('tr.k-master-row, tr.k-detail-row')) as HTMLElement | null) ?? this.navGridEditRow(currentRow))
          : null;
        const cells = isGrid
          ? (editRow ? [...new Set(Array.from(editRow.querySelectorAll<HTMLElement>(NAV_FOCUSABLE)))].filter(this.navVisible) : [])
          : this.navCells(currentRow);
        const idx = cells.findIndex((c) => focusEl != null && (c === focusEl || c.contains(focusEl)));
        const target = idx >= 0 ? cells[idx + delta] : (delta > 0 ? cells[0] : cells[cells.length - 1]);
        if (target) { target.focus(); return; }
        this.navCrossLane(currentRow, delta);
        return;
      }

      const delta = key === 'ArrowDown' ? 1 : -1;
      if (isGrid && this.navGridStep(currentRow, delta, refX)) return;
      this.navMoveVertical(currentRow, delta, refX, rows);
    },

    navMoveVertical(currentRow, delta, refX, rows) {
      const lane = this.navLaneOf(currentRow);
      const start = rows.indexOf(currentRow);
      const seq = delta > 0 ? rows.slice(start + 1) : rows.slice(0, start).reverse();
      let i = 0;
      while (i < seq.length) {
        const l = this.navLaneOf(seq[i]);
        if (lane && l && l !== lane) { i++; continue; } // másik hasáb sora: átugorjuk
        if (!lane && l) {
          // Teljes szélességű sorról hasábos blokkba lépünk: hasábonként az első (↑-nál az
          // utolsó) sor a jelölt, és a vízszintesen közelebbi nyer (oszloptartás). A blokk
          // határa a data-nav-section: a szekción BELÜLI hasáb-nélküli sor (pl. a dimenzió-
          // másoló nyilak oszlopa a két kártya közt) is jelölt, nem szakítja meg a gyűjtést.
          const section = seq[i].closest('[data-nav-section]');
          const cands: HTMLElement[] = [];
          const seen = new Set<string>();
          let j = i;
          for (; j < seq.length; j++) {
            if (!section || seq[j].closest('[data-nav-section]') !== section) break;
            const lj = this.navLaneOf(seq[j]) || t("Transactions_Mid");
            if (!seen.has(lj)) { seen.add(lj); cands.push(seq[j]); }
          }
          cands.sort((a, b) => Math.abs(this.navDistX(a, 0) - refX) - Math.abs(this.navDistX(b, 0) - refX));
          for (const c of cands) if (this.navEnterRow(c, delta, refX)) return;
          i = Math.max(j, i + 1); // a szekció mögé (vagy legalább egyet előre)
          continue;
        }
        if (this.navEnterRow(seq[i], delta, refX)) return;
        i++;
      }
    },

    // A sor szélén ←/→: átlépés a másik hasáb (data-nav-lane) azonos indexű sorába.
    navCrossLane(currentRow, delta) {
      const laneEl = currentRow.closest('[data-nav-lane]') as HTMLElement | null;
      if (!laneEl) return;
      const lane = laneEl.dataset.navLane;
      if ((lane === 'left' && delta < 0) || (lane === 'right' && delta > 0)) return; // kifelé nincs hova
      const section = laneEl.closest('[data-nav-section]') as HTMLElement | null;
      if (!section) return;
      const other = Array.from(section.querySelectorAll<HTMLElement>('[data-nav-lane]'))
        .find((el) => el !== laneEl && this.navVisible(el) && el.dataset.navLane !== lane);
      if (!other) return;
      const myRows = Array.from(laneEl.querySelectorAll<HTMLElement>('[data-nav-row]')).filter(this.navVisible);
      const otherRows = Array.from(other.querySelectorAll<HTMLElement>('[data-nav-row]')).filter(this.navVisible);
      if (!otherRows.length) return;
      const idx = Math.max(0, Math.min(myRows.indexOf(currentRow), otherRows.length - 1));
      // Jobbra átlépve a túloldali sor ELEJÉRE, balra átlépve a VÉGÉRE érkezünk.
      this.navEnterRow(otherRows[idx], 1, delta > 0 ? 0 : Number.MAX_SAFE_INTEGER);
    },

    // Belépés egy sorba; false, ha a sor most nem használható (nincs fókuszálható cellája / üres grid).
    navEnterRow(row, delta, refX) {
      if (row.dataset.navRow === 'grid') {
        const trs = this.navGridMasterRows(row);
        if (!trs.length) return false;
        const edit = this.navGridEditRow(row);
        if (edit) { this.navFocusRowCell(edit, refX, 5); return true; }
        this.navGridSelectRow(delta > 0 ? trs[0] : trs[trs.length - 1], refX);
        return true;
      }
      const cells = this.navCells(row);
      if (!cells.length) return false;
      this.navFocusNearest(cells, refX);
      return true;
    },

    navRows() {
      return Array.from((this.$el as HTMLElement).querySelectorAll<HTMLElement>('[data-nav-row]')).filter(this.navVisible);
    },

    // A sor cellái: a benne lévő fókuszálható elemek, KIVÉVE a beágyazott nav-sorokéit
    // (a closest-ellenőrzés a fül-soron belüli grid inputjait a grid sorához rendeli).
    navCells(row) {
      const cells = Array.from(row.querySelectorAll<HTMLElement>(NAV_FOCUSABLE)).filter(
        (el) => this.navVisible(el) && el.getAttribute('tabindex') !== '-1' && el.closest('[data-nav-row]') === row
      );
      return [...new Set(cells)];
    },

    navVisible(el) {
      return !!el.offsetParent;
    },

    navLaneOf(row) {
      const laneEl = row.closest('[data-nav-lane]') as HTMLElement | null;
      return laneEl ? (laneEl.dataset.navLane ?? '') : '';
    },

    // refX=0-val az elem közép-x-ét adja; egyébként a refX-től mért vízszintes távolságot.
    navDistX(el, refX) {
      const r = el.getBoundingClientRect();
      const center = r.left + r.width / 2;
      return refX ? Math.abs(center - refX) : center;
    },

    navFocusNearest(cells, refX) {
      let best = cells[0];
      let bestDist = Number.MAX_SAFE_INTEGER;
      for (const c of cells) {
        const d = Math.abs(this.navDistX(c, 0) - refX);
        if (d < bestDist) { best = c; bestDist = d; }
      }
      best?.focus();
    },

    // ===== Grid-specifikus lépések (a sor-kijelölés léptetése) =====
    navGridMasterRows(gridEl) {
      return Array.from(gridEl.querySelectorAll<HTMLElement>('tr.k-master-row')).filter(this.navVisible);
    },

    // A szerkesztett (kijelölt) sor: csak abban renderelődnek inputok.
    navGridEditRow(gridEl) {
      return this.navGridMasterRows(gridEl).find((tr) => tr.querySelector('input, textarea')) ?? null;
    },

    navGridStep(gridEl, delta, refX) {
      // A nyitott törlés-megerősítő (Kendo detail-sor, benne Megerősítés/Mégse) is léptethető sor.
      const trs = Array.from(gridEl.querySelectorAll<HTMLElement>('tr.k-master-row, tr.k-detail-row')).filter(this.navVisible);
      if (!trs.length) return false;
      const active = document.activeElement as HTMLElement | null;
      let current = active && gridEl.contains(active) ? (active.closest('tr.k-master-row, tr.k-detail-row') as HTMLElement | null) : null;
      if (!current) current = this.navGridEditRow(gridEl);
      const idx = current ? trs.indexOf(current) : -1;
      const targetIdx = idx < 0 ? (delta > 0 ? 0 : trs.length - 1) : idx + delta;
      if (targetIdx < 0 || targetIdx >= trs.length) return false; // a grid szélén: kilépés a szomszéd sorra
      const target = trs[targetIdx];
      if (target.classList.contains('k-detail-row')) {
        // megerősítő-sor: nincs kijelölés-váltás, csak fókusz a gombjaira
        this.navFocusRowCell(target, refX, 0);
      } else {
        this.navGridSelectRow(target, refX);
      }
      return true;
    },

    // Sor kijelölése a meglévő rowclick-lánccal (szintetikus kattintás a 2. cellán — az 1. cella
    // a Pontoz/kuka oszlop lehet), majd fókusz a frissen renderelt inputok közül a legközelebbire.
    navGridSelectRow(tr, refX) {
      const cell = (tr as HTMLTableRowElement).cells?.[1] ?? (tr as HTMLTableRowElement).cells?.[0] ?? tr;
      cell.dispatchEvent(new MouseEvent('click', { bubbles: true }));
      this.navFocusRowCell(tr, refX, 5);
    },

    // A kijelölés utáni inEdit-render aszinkron — pár frame-en át újrapróbáljuk a fókuszt.
    navFocusRowCell(tr, refX, attempts) {
      const cells = [...new Set(Array.from(tr.querySelectorAll<HTMLElement>(NAV_FOCUSABLE)))].filter(this.navVisible);
      if (cells.length) { this.navFocusNearest(cells, refX); return; }
      if (attempts > 0) requestAnimationFrame(() => this.navFocusRowCell(tr, refX, attempts - 1));
    },

    onRegister(components) {
      components.forEach((comp: any) =>{
        this.focusItems.push(comp)
      })
    },
    isTransactionModified() {
      return this.store.modifiedItems.length > 0 && (this.store.originalTransaction.status == 5 && this.store.transaction.status == 5);
    },
    switchTableView(){
      this.isMultiTableView = !this.isMultiTableView
      if(this.focusMode){
          this.focusMode = false
          eventBus.$emit("error", t("Transactions_UjElemHozzadasKikapcsolva"));
      }
    }
  },

  watch: {
    // Az /edit/A -> /edit/B navigáció (pl. a böngésző Vissza gombja a főkönyvi szám módosítás után)
    // ugyanazt a route-rekordot találja el, ezért a komponens NEM mountol újra – itt töltünk újra.
    "$route.params.id"(newId: string, oldId: string) {
      const id = Number(newId);
      if (!(id > 1) || newId === oldId) return;
      if (this.pendingReloadId === id) { this.pendingReloadId = null; return; } // a saját navigációnk tölti
      if (this.store.transaction.id === id) return;
      this.store.isAccnoEditMode = false;
      this.store.accnoChanges = {};
      this.reloadTransaction(id);
    },
  },

  computed: {
    // --- Főkönyvi szám módosítás mód ---
    // A gomb megjelenése KIZÁRÓLAG a backend kapuzó válaszán múlik (can-modify), hogy ne kínáljunk
    // fel olyan műveletet, amit a szerver utána elutasítana (K2D belépési guardok + f_storno lánc).
    canModifyAccounts() {
      return !!(this.accnoModGate && this.accnoModGate.canModify);
    },
    accnoModCanReverse() {
      return !!(this.accnoModGate && this.accnoModGate.canReverse);
    },
    accnoModReverseBlockedReason() {
      return (this.accnoModGate && this.accnoModGate.reverseBlockedReason) || t("Transactions_AzEredetiNemSztornozhato");
    },
    // Csak a TÉNYLEGES cserék számítanak: az eredetivel megegyező választás nem módosítás.
    accnoChangeCount() {
      return Object.keys(this.store.accnoChanges).filter(key => {
        const itemId = Number(key);
        const original = this.store.originalTransactionItems.find(x => x.id === itemId);
        return !!original && this.store.accnoChanges[itemId] !== original.invoiceMirror.id;
      }).length;
    },
    canRunAccnoMod() {
      if (this.store.isItemsLoading || this.accnoChangeCount === 0) return false;
      // Gépi tranzakciónál a sztornó kötelező, ezért ha az nem lehetséges, az egész művelet tiltott.
      if (!this.store.transaction.type && !this.accnoModCanReverse) return false;
      return true;
    },
    accnoModHint() {
      if (this.accnoChangeCount === 0) return t("Transactions_ElobbModositsonLegalabbEgyFokonyviSzamot");
      if (!this.store.transaction.type && !this.accnoModCanReverse) return this.accnoModReverseBlockedReason;
      if (!this.store.transaction.type) return t("Transactions_GepiTranzakcioAzEredetiAutomatikusanSztornozodik");
      return this.store.accnoModReverse
        ? t("Transactions_JavitottMasolatKeszulAzEredetiSztornozodik")
        : t("Transactions_JavitottMasolatKeszulAzEredetiErintetlen");
    },
    // A Mentés gomb tooltipje: tiltott gombnál a tiltás okát mondja el.
    saveHint() {
      if (this.store.isReadOnlyView) return t("Transactions_EbbenAStatuszbanATranzakcioNem_2");
      if (this.store.isItemsLoading) return t("Transactions_ATetelekBetolteseFolyamatbanVarjonA");
      if (this.error.length > 0) return t("Transactions_AMenteshezJavitsaAJelzettHibat") + this.error;
      return t("Transactions_AFejATetelekEsA");
    },
    // Az oldal címe a mód szerint (a route dönt): másolás / új / szerkesztés
    pageTitle() {
      const p = this.$route.path;
      if (p.includes('/copy/')) return t("Transactions_TranzakcioMasolasa");
      if (p.includes('/create')) return t("Transactions_UjTranzakcio");
      return t("Transactions_TranzakcioSzerkesztese");
    },
    arrayToNegative() {
      return this.store.transactionItemsDimensions.filter(
        x =>
          x.head == this.store.negativeSelectedItem.id &&
          x.dimCodeType == this.store.positiveSelectedDimCodeType
      );
    },
    arrayToPositive(){
      return this.store.transactionItemsDimensions.filter(
        x =>
          x.head == this.store.positiveSelectedItem.id &&
          x.dimCodeType == this.store.negativeSelectedDimCodeType
      );
    },
    isInSameDimension(){
      return store.positiveSelectedDimCodeType == store.negativeSelectedDimCodeType
    },
    //(Positivie <- Követel)
    isDisabledToPositive(){ //Tartozik oldalról kijelölt elemet át tudom e másolni követel oldalra
      
      // return this.isCopyDisabled(
      //   store.negativeSelectedDimension,
      //   store.negativeSelectedDimCodeType,
      //   store.positiveSelectedItem
      // )

      

      //Mindkét oldal egy dimenzión van?
      if(store.positiveSelectedDimCodeType != store.negativeSelectedDimCodeType){ // ha nem
        return true // akkor tiltsuk le a gombot
      }//ha megegyezik a dimenzió tovább számolás

      //megnézük, hogy a tartozik oldalon lévő elem ami ki van jelölve a követel oldalon van-e mar ilyen dim kódos elem
      const tartozikOldalonAktualisanKijelolt = store.negativeSelectedDimension;
      const tartozikOldalonAktualisDimenzio = store.negativeSelectedDimCodeType;
      const kovetelOldalonAktualisanKijeloltTetel = store.positiveSelectedItem;

      //ha nincs érdemi kiválasztás — az id==0 erre NEM jó teszt, mert a frissen felvett (még nem
      //mentett) sor id-je is 0; a mérvadó a dimenziókód: kód nélkül (default 1) nincs mit másolni
      if(tartozikOldalonAktualisanKijelolt.dimCode <= 1){
        return true; // akkor tiltsuk le a gombot
      }//van elem


      //kilistázzuk az elemeket a követel oldalon adot diemnzióban
      const array = store.transactionItemsDimensions.filter( x => x.head == kovetelOldalonAktualisanKijeloltTetel.id && x.dimCodeType == tartozikOldalonAktualisDimenzio);

      //megvizsgáljuk, hogy van-e a követel oldalon a dimenzióban olyan dimenzió kódú elem amit át akarunk másolni
      if(array.some(i => i.dimCode == tartozikOldalonAktualisanKijelolt.dimCode)){ //ha van
        return true // akkor tiltsuk le a gombot
      }
      //ha nincs engedélyezzük a gombot
      return false;

      

    },
    //(Negative <- Tartozik)
    isDisabledToNegative(){ //Követel oldalról kijelölt elemet át tudom e másolni tartozik oldalra


      // return this.isCopyDisabled(
      //   store.positiveSelectedDimension,
      //   store.positiveSelectedDimCodeType,
      //   store.negativeSelectedItem
      // )

      

      //Mindkét oldal egy dimenzión van?
      if(store.positiveSelectedDimCodeType != store.negativeSelectedDimCodeType){ // ha nem
        return true // akkor tiltsuk le a gombot
      }//ha megegyezik a dimenzió tovább számolás

      //megnézük, hogy a kovetel oldalon lévő elem ami ki van jelölve a tartozik oldalon van-e mar ilyen dim kódos elem
      const kovetelOldalonAktualisanKijelolt = store.positiveSelectedDimension;
      const kovetelOldalonAktualisDimenzio = store.positiveSelectedDimCodeType;
      const tartozikOldalonAktualisanKijeloltTetel = store.negativeSelectedItem;

      //ha nincs érdemi kiválasztás — az id==0 erre NEM jó teszt, mert a frissen felvett (még nem
      //mentett) sor id-je is 0; a mérvadó a dimenziókód: kód nélkül (default 1) nincs mit másolni
      if(kovetelOldalonAktualisanKijelolt.dimCode <= 1){
        return true; // akkor tiltsuk le a gombot
      }//van elem

      //kilistázzuk az elemeket a tartozik oldalon adot diemnzióban
      const array = store.transactionItemsDimensions.filter( x => x.head == tartozikOldalonAktualisanKijeloltTetel.id && x.dimCodeType == kovetelOldalonAktualisDimenzio);

      //megvizsgáljuk, hogy van-e a tartozik oldalon a dimenzióban olyan dimenzió kódú elem amit át akarunk másolni
      if(array.some(i => i.dimCode == kovetelOldalonAktualisanKijelolt.dimCode)){ //ha van
        return true // akkor tiltsuk le a gombot
      }

      //ha nincs engedélyezzük a gombot
      return false;

    },
    error(){
      for (const el of store.transactionItems) {
        if(el.invoiceMirror.id == 1){
          return t("Transactions_FokonyviSzamMezoKitolteseKotelezo")
        }
        else if(el.total == 0){
          return t("Transactions_OsszegMezoKitolteseKotelezo")
        }
        else if(el.accSign == ""){
          return t("Transactions_TetelTipusMezoKitolteseKotelezo")
        }    
        else if(!this.validDate(el.accDate)){
          return "Nincs az intervallumban!"
        }
      } 
      for (const el of store.transactionItemsDimensions) {
        if(el.dimCode == 1){
          return t("Transactions_DimenziokodMegadasaKotelezo")
        }
        else if(el.total == 0){
          return t("Transactions_OsszegMezoKitolteseKotelezo")
        }
      }
      return ""
    },
    warning() {
      return "";
    },
    isChangesHappend() {
      if(this.store.newItems.length > 0 || this.store.modifiedItems.length > 0 || this.store.newDimensions.length > 0 || this.store.modifiedDimensions.length > 0){
        return true;
      }else{
        return false;
      }
    },
    // K2D szabály (m_load enable): sablon csak MENTETT fejű, tétel nélküli, szerkeszthető
    // tranzakcióba tölthető (a backend LoadBookingTemplate szerver-oldalon is ellenőrzi).
    canLoadTemplate() {
      // isItemsLoading alatt a tételek listája még üres, ezért nélküle a gomb felvillanna
      // olyan tranzakciónál is, aminek valójában vannak tételei.
      return this.store.transaction?.id > 1
        && !this.store.isItemsLoading
        && this.store.transactionItems.length === 0
        && this.store.newItems.length === 0
        && !this.store.isReadOnlyView;
    },
    // A tiltott "Sablon betöltése" gomb tooltipje: miért nem tölthető most sablon.
    loadTemplateBlockedReason() {
      if (this.store.isReadOnlyView) return t("Transactions_EbbenAStatuszbanATranzakcioNem_3");
      if (!(this.store.transaction?.id > 1)) return t("Transactions_ElobbMentseATranzakcioFejetUtana");
      if (this.store.isItemsLoading) return t("Transactions_ATetelekBetolteseFolyamatban");
      return t("Transactions_SablonCsakTetelNelkuliTranzakciobaToltheto");
    },
  },
})
